export default __webpack_public_path__ + "static/media/boy_girl.1d5d77ea.svg";